// ============================================================
// FILE: PortfolioSection.js
// LOCATION: C:\gardenmarket\web\src\pages\gardener\PortfolioSection.js
// ============================================================
// PURPOSE:
//   Self-contained portfolio photo manager — drop this into
//   GardenerProfile.js as a new section (e.g. below the Skills
//   section). Lets a gardener directly upload sample-work photos,
//   independent of any specific job, capped at 12 photos.
//
// USAGE (inside GardenerProfile.js):
//   import PortfolioSection from './PortfolioSection';
//   ...
//   <PortfolioSection />
//
// CALLS API:
//   GET    /api/photos/portfolio/:gardenerId  — needs the
//          logged-in gardener's own gardener_id from useAuth()
//   POST   /api/photos/portfolio              — direct upload
//   DELETE /api/photos/portfolio/:id
//
// NOTE: This is intentionally a self-contained component (manages
//   its own loading state) rather than requiring GardenerProfile.js
//   to thread portfolio state through itself — keeps the change
//   to the existing profile page to a single <PortfolioSection />
//   line rather than a large merge into an unfamiliar file.
// ============================================================

import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import client from '../../api/client';
import PhotoUploader from '../../components/PhotoUploader';
import { card, cardHeader, colors } from '../../theme/theme';

export default function PortfolioSection() {
    const { user } = useAuth();
    const [photos, setPhotos] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadPhotos = async () => {
        if (!user?.gardener_id) return;
        const r = await client.get(`/photos/portfolio/${user.gardener_id}`);
        setPhotos(r.data.photos || []);
    };

    useEffect(() => {
        loadPhotos().finally(() => setLoading(false));
    }, [user?.gardener_id]);

    if (loading) return null;

    return (
        <div style={card}>
            <h3 style={cardHeader}>Portfolio — Sample Work</h3>
            <p style={styles.hint}>
                Show buyers examples of your work. These photos appear on your public profile.
            </p>
            <PhotoUploader
                uploadUrl="/photos/portfolio"
                existingPhotos={photos}
                onDeleteUrl={(photo) => `/photos/portfolio/${photo.portfolio_photo_id}`}
                onChange={loadPhotos}
                label=""
                maxFiles={12}
            />
        </div>
    );
}

const styles = {
    hint: { fontSize:'0.82rem', color: colors.textFaint, marginBottom:'12px' },
};
